import SearchableDropdown from '@comp/Dropdown/SearchableDropdown';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import { useEffect, useState } from 'react';

const DisabledField = styled.div`
  width: 100%;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'auto')};
`;

const StyledSearchableDropdown = styled(SearchableDropdown)`
  width: 100%;
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};

  &.box-wrapper {
    border-radius: ${Spacings.SPACING_2B};
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
    margin-bottom: 0;
    cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'auto')};
    background-color: var(--color-base-1);
    border-color: var(--color-divider);

    .search-dd-input-wrapper {
      cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'auto')};
    }

    .search-dd-input {
      font-size: ${Fonts.SMALL};
      font-weight: ${Fonts.REGULAR};
      color: ${({ $isDisabled }) =>
        $isDisabled
          ? 'var(--color-text-secondary)'
          : 'var(--color-text-primary)'};
      cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'text')};

      ::placeholder {
        color: var(--color-text-secondary);
      }
    }

    .search-dd-icon {
      cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
      opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
    }

    .search-dd-options {
      top: 48px;
      padding: ${Spacings.SPACING_2B} 0;
      max-height: 240px;
      border: 1px solid var(--color-divider);
      border-radius: ${Spacings.SPACING_2B};
    }
  }
`;

export const DropdownOption = styled.div`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  cursor: pointer;

  &:hover {
    background-color: var(--color-base-0);
  }
`;

const CbtSearchableSelect = ({
  options,
  selectedOption,
  onSelect,
  placeholder,
  disabled = false,
  noOptionsText = 'No result found',
  renderDropdownItem,
  isOpen,
  onToggle
}) => {
  const [internalShowDropdown, setInternalShowDropdown] = useState(false);

  // Use controlled state if provided, otherwise use internal state
  const isControlled = isOpen !== undefined && onToggle !== undefined;
  const showDropdown = isControlled ? isOpen : internalShowDropdown;

  const updateDropdownState = (newState) => {
    if (isControlled) {
      onToggle(newState);
    } else {
      setInternalShowDropdown(newState);
    }
  };

  useEffect(() => {
    if (disabled) {
      updateDropdownState(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  const handleSelect = (option) => {
    if (option?.disabled) return;
    onSelect(option);
    updateDropdownState(false);
  };

  return (
    <DisabledField $isDisabled={disabled}>
      <StyledSearchableDropdown
        isOpen={showDropdown}
        placeholder={placeholder}
        options={options}
        selectedOption={selectedOption || {}}
        labelKey="label"
        filterKey="label"
        wrapperStyle
        width="100%"
        clearOnAway={false}
        noOptionsText={noOptionsText}
        shouldHandleClickAwayManually
        $isDisabled={disabled}
        toggleSearchDropdown={(newIsOpen) => {
          if (!disabled) updateDropdownState(newIsOpen);
        }}
        onValueChange={() => {
          if (!disabled) updateDropdownState(true);
        }}
        dropdownItem={(option) =>
          renderDropdownItem ? (
            renderDropdownItem(option, () => handleSelect(option))
          ) : (
            <DropdownOption onClick={() => handleSelect(option)}>
              {option.label}
            </DropdownOption>
          )
        }
      />
    </DisabledField>
  );
};

export default CbtSearchableSelect;
